
export default {
  selectFaqList: { // 고객센터 > FAQ목록조회
    method: 'GET',
    url: 'mrm/v1/anonym/nrw/student/faqList'
  },
  selectFaqMain: { // 고객센터 > FAQ메인조회
    method: 'GET',
    url: 'mrm/v1/permit/student/faqMain'
  },
  selectVocForm: { // 고객센터 > 1:1문의 > 정보 조회
    method: 'GET',
    url: 'mrm/v1/permit/nrw/st/om/voc/vocForm'
  },
  selectVocSave: { // 고객센터 > 1:1문의 > 저장
    method: 'POST',
    url: 'mrm/v1/permit/nrw/st/om/voc/vocSave'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/custCntrApi.js